import { createSlice } from '@reduxjs/toolkit';

const paymentSlice = createSlice({
	name: 'payment',
	initialState: {
		// Estados de loading separados para cada acción
		loadingPayments: false,
		loadingPaymentsByUser: false,
		loadingSelectedPayment: false,
		loadingUpload: false,
		loadingUpdate: false,
		loadingDecline: false,
		loadingAccept: false,
		// Datos
		payments: [],
		paymentsByUser: [],
		paymentSelected: {},
	},
	reducers: {
		getAllPaymentsStart: (state) => {
			state.loadingPayments = true;
		},
		getAllPaymentsSuccess: (state, { payload: { payments } }) => {
			state.loadingPayments = false;
            state.payments = payments;
		},
		getAllPaymentsFailure: (state) => {
			state.loadingPayments = false;
		},
		getAllPaymentsByUserIdStart: (state) => {
			state.loadingPaymentsByUser = true;
		},
		getAllPaymentsByUserIdSuccess: (state, { payload: { payments } }) => {
			state.loadingPaymentsByUser = false;
            state.paymentsByUser = payments;
		},
		getAllPaymentsByUserIdFailure: (state) => {
			state.loadingPaymentsByUser = false;
		},
		getPaymentByIdStart: (state) => {
			state.loadingSelectedPayment = true;
			state.paymentSelected = {};
		},
		getPaymentByIdSuccess: (state, { payload: { payment } }) => {
			state.loadingSelectedPayment = false;
            state.paymentSelected = payment;
		},
		getPaymentByIdFailure: (state) => {
			state.loadingSelectedPayment = false;
		},
		uploadPaymentStart: (state) => {
			state.loadingUpload = true;
		},
		uploadPaymentSuccess: (state) => {
			state.loadingUpload = false;
		},
		uploadPaymentFailure: (state) => {
			state.loadingUpload = false;
		},
		updatePaymentStart: (state) => {
			state.loadingUpdate = true;
		},
		updatePaymentSuccess: (state) => {
			state.loadingUpdate = false;
		},
		updatePaymentFailure: (state) => {
			state.loadingUpdate = false;
		},
		declinePaymentStart: (state) => {
			state.loadingDecline = true;
		},
		declinePaymentSuccess: (state) => {
			state.loadingDecline = false;
		},
		declinePaymentFailure: (state) => {
			state.loadingDecline = false;
		},
		acceptedPaymentStart: (state) => {
			state.loadingAccept = true;
		},
		acceptedPaymentSuccess: (state) => {
			state.loadingAccept = false;
		},
		acceptedPaymentFailure: (state) => {
			state.loadingAccept = false;
		},
        cleanSelectedPayment: (state) => {
            state.paymentSelected = {};
            state.paymentsByUser = [];
        }
	},
});

export const {
	getAllPaymentsStart,
	getAllPaymentsSuccess,
	getAllPaymentsFailure,
	getAllPaymentsByUserIdStart,
	getAllPaymentsByUserIdSuccess,
	getAllPaymentsByUserIdFailure,
	getPaymentByIdStart,
	getPaymentByIdSuccess,
	getPaymentByIdFailure,
	uploadPaymentStart,
	uploadPaymentSuccess,
	uploadPaymentFailure,
	updatePaymentStart,
	updatePaymentSuccess,
	updatePaymentFailure,
	declinePaymentStart,
	declinePaymentSuccess,
	declinePaymentFailure,
	acceptedPaymentStart,
	acceptedPaymentSuccess,
	acceptedPaymentFailure,
    cleanSelectedPayment,
} = paymentSlice.actions;
export default paymentSlice.reducer;